type Combination = {
    pvv_variacao_idpk: number;
    pvv_valor: string;
};

type Variation = {
    pve_variacao_idpk?: number | null;
    valor?:
        | {
              pvv_valor?: string | null;
              excluir?: 'S' | null;
          }[]
        | null;
};

export function generateCombinations(variations: Variation[]): Combination[][] {
    if (variations.length === 0) {
        return [[]];
    }

    const [currentVariation, ...remainingVariations] = variations;
    const remainingCombinations = generateCombinations(remainingVariations);

    const combinations: Combination[][] = [];

    if (!currentVariation?.pve_variacao_idpk) {
        return [];
    }

    for (const value of currentVariation.valor || []) {
        if (!value.pvv_valor || value.excluir === 'S') {
            continue;
        }

        for (const combination of remainingCombinations) {
            combinations.push([
                {
                    pvv_valor: value.pvv_valor,
                    pvv_variacao_idpk: currentVariation.pve_variacao_idpk,
                },
                ...combination,
            ]);
        }
    }

    return combinations;
}
